module.exports = __webpack_public_path__ + "static/media/performance-success.47612d2d.jpeg";